import { createContext } from "core/utils/context";

export const initialState = {
  loading: false,
  setLoading: () => undefined
};

export const { context: FormContext } = createContext("FormContext", initialState);
